const isCustomEvent = <T>(event: Event): event is CustomEvent<T> =>
	"detail" in event;

export const subscribeHostCustomEvent = <T>(input: {
	eventName: string;
	onEvent: (detail: T, event: CustomEvent<T>) => void;
	signal?: AbortSignal;
	windowRef: Window;
}): (() => void) => {
	const targetWindow = input.windowRef;

	const handler = (event: Event): void => {
		if (!isCustomEvent<T>(event)) {
			return;
		}
		input.onEvent(event.detail, event);
	};

	let unsubscribed = false;
	const signal = input.signal;
	let abortHandler: (() => void) | null = null;

	const unsubscribe = (): void => {
		if (unsubscribed) {
			return;
		}
		unsubscribed = true;
		targetWindow.removeEventListener(input.eventName, handler);
		if (signal && abortHandler) {
			signal.removeEventListener("abort", abortHandler);
		}
	};

	targetWindow.addEventListener(input.eventName, handler);

	if (signal) {
		abortHandler = () => {
			unsubscribe();
		};
		if (signal.aborted) {
			unsubscribe();
			return unsubscribe;
		}
		signal.addEventListener("abort", abortHandler, { once: true });
	}

	return unsubscribe;
};
